<div mat-dialog-title style="margin:0px;">
    <div style="padding-left:10px;padding-top:10px;">
        Override Credit Code
    </div>
</div>

<mat-dialog-content>
    <div id="divcreditCode" style="padding:10px;margin-bottom:70px;overflow:auto;">
        <table class="mastertable">
            <tbody>
                <tr *ngIf="!fromAcademicProgress">
                    <td>
                        <tyl-form-field style="width: 450px;" label='Courses'>
                            <mat-select id="dropdownCourses" aria-label="Courses dropdown" tabindex="0"
                                [(ngModel)]="course_Id" (ngModelChange)="course_change();">
                                <mat-option [value]="-1" *ngIf="gpCourses && gpCourses.length === 0" translate>(Not Available)
                                </mat-option>
                                <mat-option *ngFor="let c of gpCourses" [value]="c.Course_ID">
                                    {{ c.Course }}
                                </mat-option>
                            </mat-select>
                        </tyl-form-field>
                    </td>
                </tr>
                <tr *ngIf="!fromAcademicProgress">
                    <td>
                        <tyl-form-field style="width: 450px;" label='Graduation Plans'>
                            <mat-select id="dropdownGraduationPlan" aria-label="Graduation Plan dropdown" tabindex="1"
                                [(ngModel)]="gradPlan_Id" (ngModelChange)="gradPlan_change();">
                                <mat-option [value]="-1" *ngIf="graduationPlans && graduationPlans.length === 0" translate>(Not Available)
                                </mat-option>
                                <mat-option *ngFor="let gp of graduationPlans" [value]="gp.GradPlan_ID">
                                    {{ gp.GradPlanName }}
                                </mat-option>
                            </mat-select>
                        </tyl-form-field>
                    </td>
                </tr>
                <tr>
                    <td colspan="2">
                        <table class="studentinfo">
                            <tbody>
                                <tr>
                                    <th style="width: 20%;" translate>Student Name:</th>
                                    <td style="width: 30%;">{{gpGPStudentNCourseInfoModel?.StudentName}}</td>
                                    <th style="width: 20%;" translate>Student Number:</th>
                                    <td style="width: 30%;">{{gpGPStudentNCourseInfoModel?.StudentNumberIdentifier}}
                                    </td>
                                </tr>
                                <tr>
                                    <th translate>Course Identifier:</th>
                                    <td>{{gpGPStudentNCourseInfoModel?.SubjectIdentifier}}</td>
                                    <th translate>Course Name:</th>
                                    <td>{{gpGPStudentNCourseInfoModel?.SubjectName}}</td>
                                </tr>
                                <tr>
                                    <th translate>Section Name:</th>
                                    <td>{{gpGPStudentNCourseInfoModel?.SectionName}}</td>
                                    <th translate>Academic Year:</th>
                                    <td>{{yearService.student360Year.AYIdentifier}}</td>
                                </tr>
                                <tr>
                                    <th translate>Credit Code(s):</th>
                                    <td colspan="3">{{gpGPStudentNCourseInfoModel?.CreditCode}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
                <tr>
                    <td>
                        <tyl-form-field style="width: 450px;" label='Override Credit Code'>
                            <mat-select id="dropdownOverrideCreditCodes" aria-label="Override Credit Codes dropdown"
                                tabindex="2" [(ngModel)]="override_creditcode" required>
                                <mat-option [value]="-1" *ngIf="gpOverrideCreditCodes && gpOverrideCreditCodes.length > 0" translate>
                                </mat-option>
                                <mat-option [value]="-1" *ngIf="gpOverrideCreditCodes.length === 0" translate>(Not
                                    Available)</mat-option>
                                <mat-option *ngFor="let cc of gpOverrideCreditCodes" [value]="cc.CreditCode">
                                    {{ cc.CreditCode }}
                                </mat-option>
                            </mat-select>
                        </tyl-form-field>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <div class="flex-footer-right">
        <error-prompt [errorList]="errorList"> </error-prompt>
        <save-cancel-buttons id="btnSaveCancel" aria-label="Override Credit Codes" tabindex="3"
            (saveButtonEvent)="saveOrCancel($event)" [saveServerEvent]="saveEvent"></save-cancel-buttons>
    </div>
</mat-dialog-actions>